export default __webpack_public_path__ + "static/media/blob-right-origin.f56cdafe.png";